// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTOMATIC_COMMENT_VIOLATES_RULES = "Nahl\u00e1s nevhodn\u00fa odpove\u010f";
export const DELETE = "Zma\u017e";
export const FORUM_COMMENT_EDIT_MENU = "Uprav";
export const FORUM_COMMENT_MOVE_UP = "Posun\u00fa\u0165 odpove\u010f nahor";
export const SEND_HEART_TO_username = "Po\u0161li srdie\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017e\u00edvate\u013eky, ktor\u00fdm sa to p\u00e1\u010di";
